"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _SendReceiveConfirmHeaderComponent = _interopRequireDefault(require("./SendReceiveConfirmHeaderComponent"));
require("./SendReceiveConfirmModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('send-receive-confirm-modal');
var SendReceiveConfirmModal = function SendReceiveConfirmModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('send'),
    t = _useTranslation.t;
  var isOpen = props.isOpen,
    close = props.close,
    product = props.product,
    isSend = props.isSend,
    values = props.values,
    onConfirm = props.onConfirm,
    useExternalAddress = props.useExternalAddress,
    fee = props.fee,
    TicketAmount = props.TicketAmount,
    hideFees = props.hideFees,
    template = props.template;
  var addressLabel = t('External Address');
  var sendLabel = t('Recipient’s Email');
  var receiveLabel = t('Requestee’s Email');
  var totalAmount = TicketAmount + fee;

  // Check if travel rule fields are present
  var hasTravelRuleFields = template && template.TravelRuleFields;

  // Render travel rule fields if they exist
  var renderTravelRuleFields = function renderTravelRuleFields() {
    if (!hasTravelRuleFields) return null;
    try {
      var travelRuleFields = Array.isArray(template.TravelRuleFields) ? template.TravelRuleFields : JSON.parse(template.TravelRuleFields);
      return travelRuleFields.map(function (fieldData) {
        return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
          key: fieldData.Name,
          label: fieldData.Label,
          text: values[fieldData.Name] || '',
          customClass: bemClasses()
        });
      });
    } catch (e) {
      console.error('Error parsing TravelRuleFields in send confirmation:', e);
      return null;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: /*#__PURE__*/_react["default"].createElement(_SendReceiveConfirmHeaderComponent["default"], {
      isSend: isSend,
      product: product
    }),
    close: close,
    footer: {
      buttonText: t('Confirm'),
      buttonStyle: 'additive',
      onClick: onConfirm
    },
    customClass: bemClasses('', {
      'travel-rule-fields': hasTravelRuleFields
    })
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: bemClasses('title')
  }, t('Confirmation')), /*#__PURE__*/_react["default"].createElement("section", {
    className: bemClasses('details')
  }, !useExternalAddress && /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: isSend ? sendLabel : receiveLabel,
    text: values.ReceiverUsername,
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(product.Product || product.ProductSymbol, " ").concat(t('Amount')),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(TicketAmount, product.Product || product.ProductSymbol), " ").concat(product.Product || product.ProductSymbol),
    customClass: bemClasses()
  }), useExternalAddress && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideFees && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Miner Fees'),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(fee, product.Product || product.ProductSymbol), " ").concat(product.Product || product.ProductSymbol),
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(product.Product || product.ProductSymbol, " ").concat(t('Total Amount')),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(totalAmount, product.Product || product.ProductSymbol), " ").concat(product.Product || product.ProductSymbol),
    customClass: bemClasses()
  })), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: addressLabel,
    text: values.ExternalAddress,
    customClass: bemClasses()
  })), renderTravelRuleFields(), !useExternalAddress && /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Note'),
    text: values.Notes,
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Time'),
    text: (0, _dateHelper.formatDateTime)(new Date()),
    customClass: bemClasses()
  })));
};
SendReceiveConfirmModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  isSend: _propTypes["default"].bool.isRequired,
  fee: _propTypes["default"].number.isRequired,
  TicketAmount: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  useExternalAddress: _propTypes["default"].bool.isRequired,
  values: _propTypes["default"].object.isRequired,
  onConfirm: _propTypes["default"].func.isRequired,
  template: _propTypes["default"].object
};
var _default = exports["default"] = SendReceiveConfirmModal;